import { CircularProgress, Stack } from "@mui/material";

export function Loading() {
    return (
        <Stack direction="row">
            <CircularProgress sx={{ width: "5px" }} size={20} />
            <span style={{ fontSize: 12 }}>加载中, 若长时间未展示可尝试更换梯子节点并刷新网页</span>
        </Stack>
    );
}
